import type { ProjectLookupData } from '@/api/project'
import { isSimpleSignupEnabled } from '@/utils/earnPolicy'
import { findProjectSetting } from '@/utils/projectSettings'

/** 로그아웃까지 유지하는 프로젝트 lookup 결과 (AuthInfo와 분리) */
export type ProjectContext = ProjectLookupData

const PROJECT_CONTEXT_KEY = 'projectContext'

export const saveProjectContext = (context: ProjectContext): void => {
  localStorage.setItem(PROJECT_CONTEXT_KEY, JSON.stringify(context))
}

export const getProjectContext = (): ProjectContext | null => {
  try {
    const stored = localStorage.getItem(PROJECT_CONTEXT_KEY)
    return stored ? (JSON.parse(stored) as ProjectContext) : null
  } catch {
    return null
  }
}

export const clearProjectContext = (): void => {
  localStorage.removeItem(PROJECT_CONTEXT_KEY)
}

/** settings 내 EARN_POLICY (PROJECT 등 그룹 하위 포함) */
export const getEarnPolicy = (): unknown => {
  return findProjectSetting(getProjectContext()?.settings, 'EARN_POLICY')
}

export function getEarnPolicyFromContext(context: ProjectContext): unknown {
  return findProjectSetting(context.settings, 'EARN_POLICY')
}

/** 현재 프로젝트 간편가입(EARN_POLICY) 사용 여부 */
export const isProjectSimpleSignupEnabled = (): boolean => {
  return isSimpleSignupEnabled(getEarnPolicy())
}

export function isContextSimpleSignupEnabled(context: ProjectContext): boolean {
  return isSimpleSignupEnabled(getEarnPolicyFromContext(context))
}
